interface CheckCircleOpenIconProps {
  width?: string | number;
  height?: string | number;
  color?: string;
}

export const CheckCircleOpenIcon = ({
  width = 24,
  height = 24,
  color = '#3180C6',
}: CheckCircleOpenIconProps): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
